"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollDirection = void 0;
const react_1 = require("react");
function useScrollDirection() {
    const [direction, setDirection] = (0, react_1.useState)(null);
    const prevScrollPosition = (0, react_1.useRef)(0);
    const handleScroll = (0, react_1.useCallback)(() => {
        const currentScroll = window.scrollY;
        const smaller = currentScroll < prevScrollPosition.current;
        if (smaller) {
            setDirection('up');
        }
        else {
            setDirection('down');
        }
        prevScrollPosition.current = currentScroll;
    }, []);
    (0, react_1.useEffect)(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });
    return direction;
}
exports.useScrollDirection = useScrollDirection;
